<template>
  <div class="surface-sections">
    <surface-section v-for="section in sortedSections"
                     :id="'section-'+ section.id"
                     :key="section.id"
                     :section="section" />
    <div class="add-section-frame">
      <button v-if="canAddSection && !isNewSectionBeingAdded"
              class="flat-button muted-button add-section"
              @click="addSection"
              v-t>Add column</button>
    </div>
  </div>

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import IntlMixin from 'vuemixins/intl_mixin'
import SectionsOrderSortMixin from 'vuemixins/sections_order_sort_mixin'
import SurfaceSection from 'vuecomponents/surface_section'
import sectionSorter from 'bits/section_sorter'

export default {
  components: { SurfaceSection },
  mixins: [
    IntlMixin,
    SectionsOrderSortMixin
  ],
  computed: {
    ...mapState([
      'wall',
    ]),
    ...mapState('section', ['sectionsFetched', 'sectionBeingEditedId']),
    ...mapGetters('section', {
      wallSections: 'sections'
    }),
    ...mapGetters([
      'canIModerate',
      'isAPanelVisible',
    ]),
    sortedSections () { return sectionSorter.sortSections(this.wallSections) },
    isEmptyState () {
      return this.sortedSections.length === 0 ||
      (this.sortedSections.length === 1 &&
      !!this.sectionBeingEditedId &&
      this.sectionBeingEditedId === this.sortedSections[0].id)
    },
    canAddSection () { return this.canIModerate && !this.isEmptyState },
    isNewSectionBeingAdded () { return String(this.sectionBeingEditedId).startsWith('new_') }
  },
  watch: {
    isAPanelVisible: 'addSectionIfNone',
  },
  beforeMount () {
    this.addSectionIfNone()
  },
  mounted () {
    this.initializeSectionsOrderSort()
  },
  updated () {
    this.addSectionIfNone()
  },
  methods: {
    ...mapActions('section', ['sortedSection', 'startNewSection', 'startWithNoSections']),
    addSectionIfNone () {
      // This will add a section, so it won't go into an infinite loop
      if (this.sortedSections.length === 0 && this.sectionsFetched && !this.isAPanelVisible) {
        this.startWithNoSections()
      }
    },
    newSection () {
      // sections always left to right
      // bottomSortIndex will give us the rightmost
      return {
        sort_index: sectionSorter.getBottomSortIndex()
      }
    },
    addSection () {
      this.startNewSection({ section: this.newSection() })
    }
  }

}
</script>

<style lang="scss">
@import "./../../assets/stylesheets/3/modules/all";
$shelf-post-width: 254px;

html[data-layout=shelf] {
  #wall-container {
    overflow: hidden;

    //not sure why this works but this is the only way
    //to keep header and wish list from going bonkers.
    align-items: flex-end;
  }

  .wish-sizer {
    width: $shelf-post-width;
  }

  // #wall-container {
  //   height: 100vh;
  //   max-height: 100vh;
  // }

  #wish-list {
    display: flex;
    flex-direction: column;
    flex-shrink: 1;
    padding-bottom: 0;
    overflow-x: auto;
    width: 100%;
  }

  .wish {
    margin: 0 0 12px 0;
    display: block;
    width: $shelf-post-width;
    flex-shrink: 0;

    @include respondToPhone {
      margin: 0 0 8px 0;
    }
  }

  .wish:last-of-type {
    margin: 0;
  }

  .wish:first-of-type {
    .surface-post-actions {
      .actions-icon-list {
        top: 0px;
      }
    }
  }

  .add-post + .section-posts {
    .wish:last-of-type {
      margin: 0 0 12px 0;
    }
  }

  .wish.ui-sortable-helper {
    cursor: grabbing;
    a {
      cursor: grabbing;
    }
    transform: rotate(-2deg);
    transition: transform 0.125s;
    @include shadow-z4;

    .surface-post-actions {
      display: none;
    }
  }

  #wish-list.ui-sortable-clipped {
    .wish:not(.ui-sortable-helper) {
      max-height: 144px !important;
      overflow: hidden;
    }
  }
}

.surface-sections {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 8px 8px 0;
  box-sizing: border-box;
  flex-grow: 1;
  flex-shrink: 1;

  @include respondToPhone {
    padding: 8px 4px 0;
  }

  button.add-section {
    position: relative;
    top: 2px;
  }
}

//RESPONSIVENESS
//TODO put all responsive stuff here
html[data-layout=shelf] {
  &.firefox.windows .wish {
    margin: 0 18px 12px 0;
  }

  &.chrome.windows .wish {
    margin: 0 3px 12px 0;
  }

  &.read-only {
    .surface-section .section-posts {
      padding: 0 0 16px 0;
    }
    .add-post, .add-section-frame {
      //hide buttons in readonly view
      display: none;
    }
  }
  &.screenshot {
    body {
      //this allows the page to stretch as wide as the content
      //so we can take the screenshot. since we use chrome for
      //screenshotting, the webkit only property is enough
      min-width: -webkit-min-content;
    }

    .surface-header {
      min-width: 1024px
    }
  }
}

//RESPONSIVENESS
//TODO put all responsive stuff here
html[data-layout=shelf] {
  &.firefox.windows .wish {
    margin: 0 18px 12px 0;
  }

  &.chrome.windows .wish {
    margin: 0 3px 12px 0;
  }

  &.read-only {
    padlet-section .section-posts {
      padding: 0 0 16px 0;
    }
    .add-post, .add-section-frame {
      //hide buttons in readonly view
      display: none;
    }
  }
  &.screenshot {
    body {
      //this allows the page to stretch as wide as the content
      //so we can take the screenshot. since we use chrome for
      //screenshotting, the webkit only property is enough
      min-width: -webkit-min-content;
    }

    .surface-header {
      min-width: 1024px
    }
  }
}
</style>
